import { useEffect, useState } from 'react';
import { coreApi } from '../../../utils/axios';
import { WebsiteSection } from '../types/sections';
import errorRoutine from '../../../utils/errorRoutine';

export const useWebsiteSections = (orgId: string) => {
  const [websiteSections, setWebsiteSections] = useState<WebsiteSection[]>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    const fetch = async () => {
      try {
        setIsLoading(true);

        const { data } = await coreApi.get<{ data: WebsiteSection[] }>(`/website/sections`);
        const fetchedSections = data.data;

        setWebsiteSections(fetchedSections);
      } catch (err) {
        errorRoutine(err, setError);
        alert(err);
      } finally {
        setIsLoading(false);
        setIsLoaded(true);
      }
    };

    fetch();
  }, [orgId]);

  return { websiteSections, isLoading, isLoaded, error };
};
